'use strict';

angular.module(ApplicationConfiguration.applicationModuleName).controller('customerEditCtrl', function (
	$scope, $rootScope, $window, $state, $http, $filter, permissionService, MessageService, model, Customer, states, customersTypes, Internal, enumerators) {
	var vm = this;

	vm.states = states;
	vm.customersTypes = customersTypes;
	vm.enumerators = enumerators;
	vm.projectModule = config.projectModule;

	vm.permissions = permissionService;
	if (!vm.permissions.isAdminAccessAuthorized())
		return;

	var $translate = $filter('translate');

	vm.model = model;
	vm.isOwnCustomer = false;
	if (vm.model.customersTypeId && vm.model.customersTypeId == window.enumerators.customersTypes.Propria) {
		vm.isOwnCustomer = true;
	}

	angular.extend($scope.$parent.vm, {
		title: 'customers.settings.title',
		insertUrl: null
	});

	$rootScope.laddaLoading = false;

	vm.save = function () {
		var _isSaoPaulo = vm.verifyColorsAndSaoPaulo();
		if (_isSaoPaulo && (!(vm.model.isSPCapitol ?? false) && !(vm.model.isSPNotCapitol ?? false))) {
			MessageService.alertError(
				"Ao Selecionar o Estado de São Paulo, você deve determinar se é Capital ou Interior."
			);
			return;
		}

		$rootScope.laddaLoading = true;
		if (!vm.model.customerId) {
			Customer.insert(vm.model, function () {
				$state.go('main.customer');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		} else {
			Customer.update(vm.model, function () {
				$state.go('main.customer');
			}, function (response) {
				MessageService.alertError(response.data);
			});
		}
	}

	// vm.getSalespeople = function (val) {
	// 	return Internal.ownUsersList({ pageSize: 50, keyword: val, isManager: false }).$promise;
	// };

	// $scope.$watch('vm.salesman', function (newValue, oldValue) {
	//     if (newValue) {
	//         var exist = false;

	//         if (!vm.model.salespeople) {
	//             vm.model.salespeople = [];
	//         }
	//         vm.model.salespeople.map(x => {
	//             if (newValue.userId == x.userId) {
	//                 exist = true;
	//             }
	//         });

	//         if (!exist) {
	// 			vm.model.salespeople.push(newValue);
	//         }

	//         vm.salesman = null;
	//     }
	// });

	// vm.delUser = function(x) {
	// 	vm.model.salespeople.splice(x, 1);
	// }

	$scope.$watch('vm.model.isSPCapitol', function (newValue, oldValue) {
		if (vm.model.isSPNotCapitol && newValue) {
			vm.model.isSPNotCapitol = false;
		}
	});

	$scope.$watch('vm.model.isSPNotCapitol', function (newValue, oldValue) {
		if (vm.model.isSPCapitol && newValue) {
			vm.model.isSPCapitol = false;
		}
	});

	vm.verifyColorsAndSaoPaulo = function () {
		if (vm.projectModule == "Colors" && vm.model.stateId && vm.model.stateId == 25) {

			vm.model.isSPCapitol = vm.model.isSPCapitol ?? false;
			vm.model.isSPNotCapitol = vm.model.isSPNotCapitol ?? false;

			return true;
		}

		vm.model.isSPCapitol = null;
		vm.model.isSPNotCapitol = null;

		return false;
	}
});